export default "__VITE_ASSET__BqvDFnqF__"